/*
 * Page Name
 */

jQuery(document).ready(function () {
    /*homepage*/
    const ind_block01_slider = new Swiper('.ind_block01_slider', {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        speed: 800,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 40
            },
        }

    });
    jQuery(document).on('mouseenter', '.ind_block02_box .ind_block02_link a', function () {
        jQuery(this).closest('.ind_block02_box').addClass('is-link-hover');
    }).on('mouseleave', '.ind_block02_box .ind_block02_link a', function () {
        jQuery(this).closest('.ind_block02_box').removeClass('is-link-hover');
    });

    jQuery(document).on('mouseenter', '.ind_block03_info .btn', function () {
        jQuery(this).closest('._item').addClass('is-btn-hover');
    }).on('mouseleave', '.ind_block03_info .btn', function () {
        jQuery(this).closest('._item').removeClass('is-btn-hover');
    });
    _heightline({
        itemClsName: '.ind_block03_info ._text',
        itemPerRow: is_smp ? 5 : 4,
    });
    _heightline({
        itemClsName: '.ind_block03_info ._des',
        itemPerRow: is_smp ? 5 : 4,
    });
    if (is_smp) {
        var $el = jQuery('.ind_block03_info');
        var $wrapper = $el.find('.swiper-wrapper');
        var $slides = $wrapper.find('.swiper-slide');

        if ($slides.length < 4) {
            $slides.clone().appendTo($wrapper);
        }

        var ind_block03_info = new Swiper(".ind_block03_info", {
            loop: true,
            centeredSlides: true,
            slidesPerView: 1.11,
            spaceBetween: 10,
            watchOverflow: true,
            navigation: {
                nextEl: ".ind_block03_info .swiper-button-next",
                prevEl: ".ind_block03_info .swiper-button-prev",
            },
            
        });
    }
    /*end homepage*/

});